import { render, staticRenderFns } from "./CustomerNewCount.vue?vue&type=template&id=228ddb38&"
import script from "./CustomerNewCount.vue?vue&type=script&lang=js&"
export * from "./CustomerNewCount.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNewCount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports